import { combineReducers, createStore, applyMiddleware, Reducer } from "redux";
import thunk from "redux-thunk";
import {
  userAuthReducer,
  userForgetPasswordUpdateReducer,
  userProfileReducer,
  userSubscribeReducer,
} from "reducer/userReducers";
import { cartReducer } from "reducer/cartReducers";
import { notificationReducer } from "reducer/notificationReducers";
import {
  ongoingOrderReducer,
  inOrderReducer,
  outOrderReducer,
  getTransactionReducer,
} from "reducer/orderReducers";
import {
  productDetailsReducer,
  productLatestReducer,
  productTopReducer,
  productListReducer,
  productUploadReducer,
  productLikedReducer,
  productReviewReducer,
  productSingleReducer,
  categoryCountReducer,
  productDeleteReducer,
} from "reducer/productReducers";
import { addressListReducer } from "reducer/addressReducers";
import { dummyImages } from "containers/PageAddListing1/PageAddListing7";
import { ITransaction } from "types/interfaces";

const allReducer: Reducer = combineReducers({
  userInfo: userAuthReducer,
  userProfile: userProfileReducer,
  userSubscribe: userSubscribeReducer,
  userForgetPasswordUpdate: userForgetPasswordUpdateReducer,
  addressList: addressListReducer,
  likedProduct: productLikedReducer,
  productList: productListReducer,
  productLatest: productLatestReducer,
  productDetail: productDetailsReducer,
  productReview: productReviewReducer,
  productTopReducer: productTopReducer,
  productUpload: productUploadReducer,
  productSingle: productSingleReducer,
  productDelete: productDeleteReducer,
  ongoingOrder: ongoingOrderReducer,
  inOrder: inOrderReducer,
  outOrder: outOrderReducer,
  orderSingle: getTransactionReducer,
  cart: cartReducer,
  categoryCount: categoryCountReducer,
  notification: notificationReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo") || "tidak ada")
  : null;

const cartItemsFromStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems") || "tidak ada")
  : null;

const AddressFromStorage = localStorage.getItem("addresses")
  ? JSON.parse(localStorage.getItem("addresses") || "tidak ada")
  : null;

const ongoingOrderFromStorage = localStorage.getItem("ongoingOrder")
  ? JSON.parse(localStorage.getItem("ongoingOrder") || "tidak ada")
  : null;

const likedProductFromStorage = localStorage.getItem("likedProduct")
  ? JSON.parse(localStorage.getItem("likedProduct") || "tidak ada")
  : null;

const subscribedUserFromStorage = localStorage.getItem("subscribedUser")
  ? JSON.parse(localStorage.getItem("subscribedUser") || "tidak ada")
  : null;

export const productUploadInitial = {
  images: dummyImages,
  imagesSent: [],
  name: "",
  category: "Transporatasi",
  description: "",
  address: {},
  locations: [],
  price: "1",
  edit: false,
  minRent: "1",
  deposit: "0",
};

const transactionInitial: ITransaction = {
  product: { description: "", images: [""], name: "" },
  productStatus: {
    reviews: [],
    rating: 0,
  },
  profile: {
    displayName: "",
  },
  transaction: {
    createdAt: "",
    days: 1,
    delivery: "",
    discount: 0,
    dropOff: { name: "", price: 0 },
    endDate: "",
    endTime: "",
    pickUp: { name: "", price: 0 },
    price: 0,
    productId: "",
    renterId: "",
    startDate: "",
    startTime: "",
    status: "",
    total: 0,
    updatedAt: "",
    vendorId: "",
    _id: "",
  },
};

const initialState = {
  userInfo: { userInfo: userInfoFromStorage },
  cart: { cartItem: cartItemsFromStorage },
  ongoingOrder: { ongoingOrder: ongoingOrderFromStorage },
  productUpload: { product: productUploadInitial },
  addressList: { addresses: AddressFromStorage },
  likedProduct: { likedProducts: likedProductFromStorage },
  userSubscribe: { subscribedUser: subscribedUserFromStorage },
  orderSingle: { transaction: transactionInitial },
};

const store = createStore(
  allReducer,
  initialState,
  applyMiddleware(thunk) /* preloadedState, 
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()*/
);

export type RootState = ReturnType<typeof allReducer>;

export default store;
